export const environment = {
  appID: "ai-leap-ilgjp",
  production: false,
  // Draft-course preview: paused (unpublished) courses stay fully executable
  // so testers can run the content being edited. Never true in production.
  draftCoursePreview: true,
  auth0: {
    domain: 'mindlife-uplift.uk.auth0.com',
    clientId: 'MA1SfavUKp7wJWijHEJNYwcBP38vSLrG',
    audience: 'https://api.upliftx.net',
    redirectUri: 'https://staging.user.mindlife.app/callback',
    useRefreshTokens: true,
  },
  apiUrl: 'https://ai-leap-production.up.railway.app',
  allContentCollection: "interventions",
  allContentDB: "aileap",
  assessmentCollection: "all_content_test",
  assessmentDB: "aileap",
  createWebinarFunction: "create-webinar-dev",
  currentProgressCollection: "interventions_being_executed_test",
  databaseName: "aileap",
  groupListCollection: "groups_test",
  groupProtocolLisCollection: "courses",
  groupProtocolListDB: "aileap",
  groupsListDB: "aileap",
  journalEntryCollection: "journal_item_entries_test",
  lifePracticeCollection: "life_practice_test",
  lifePracticeCustomCollection: "custom_life_practices",
  lifePracticeCustomEntriesCollection: "custom_life_practice_entries_test",
  lifePracticeResultCollection: "session_results",
  lifePracticeResultDB: "aileap",
  liveQuestCollection: "orbit_live_quest_test",
  liveQuestDB: "aileap",
  organisationCollection: "organisations_dev",
  patientProfileCollection: "patient_profile_test",
  profileDB: "aileap",
  protocolCollection: "protocols",
  protocolDB: "aileap",
  questResultCollection: "session_results",
  questResultDB: "aileap",
  serviceName: "mongodb-atlas",
  sessionCollection: "all_content_test",
  sessionDB: "aileap",
  sessionResultDB: "aileap",
  sessionResultsCollection: "session_results",
  updateWebinarFunction: "reset-webinar-dev",
  userProfileCollection: "profiles",
  userProfileDB: "aileap",
  webinarDB: "aileap",
  webinarListCollection: "webinars_test",
  notificationDB: "aileap",
  notificationCollection: "notifications_test",
  notificationItemCollection: "notification_items_test",
  getSmsNumberVerificationCodeFunction: "request-sms-verification-dev",
  confirmSmsNumberVerificationFunction: "confirm-sms-verification-dev",
  skillEntryCollection: "skill_check_entries_test",
  passwordResetModeForPatient: "patientPasswordDev",
  posthog: {
    key: "phc_CL2nigAfbftS4AjbtCjZ5bh5MwqY4UzJB8x6T4RAxvKf",
    host: "https://eu.i.posthog.com",
  },
  sentry: {
    dsn: "https://7b1521af31a6c3c6b573d54b9706593f@o4511309161103360.ingest.de.sentry.io/4511309167591504",
    environment: "staging",
  },
};
